module.exports = __webpack_public_path__ + "static/media/alladinpro.0eb488de.jpg";